module.exports = __webpack_public_path__ + "4f67de98221b9bfffa78b581d596d983.png";